import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

export const isUpcomingSaleDefinition = definitionFactory({
  key: 'is_upcoming_sale',
  mapper: jsonQueryValue => {
    return [
      {
        label: 'Скоро в продаже',
        value: jsonQueryValue,
      },
    ];
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'is_upcoming_sale', options);
  },
});
